import React, { Component } from 'react';
import './BooksRequest.css';
import { connect } from 'react-redux';
import { Col, Row } from "react-bootstrap";
import Modal from 'react-modal';
import { BOOK_STATUS_LIST } from '../../utils/bookStatusList'
import { createNotification } from '../notifications/notifications';
import { notificationsLibrary } from '../../utils/notificationsLibrary.js';
import EditBookRequestbookForm from './EditBookRequestbookForm';
import BookSearchForm from '../BookSearchForm';

const mapStateToProps = booksRequest => ({
  libraryList: booksRequest.booksRequest.libraryData,
});


class BooksRequestList extends Component {
  state = {
    isBookSearchOpen: false,
    isBookResultsRequested: false,
    isLibraryDataLoading: false,
    isEditModalVisible: false,
    smallModalData: {}
  }

  searchBooksList = (event) => {
    event.preventDefault();
    let requestBody = {
      "author": event.target.author.value,
      "bbk": event.target.bbk.value,
      "category": event.target.category.value,
      "discipline": event.target.discipline.value,
      "idclient": "",
      "isbn": event.target.isbn.value,
      "publisher": event.target.publisher.value,
      "textsearch": "",
      "title": event.target.title.value,
      "udk": "",
      "verifyStatus": event.target.status.value,
      "year": event.target.year.value
    };
    this.setState({
      isLibraryDataLoading: true,
      isBookResultsRequested: true
    });
    this.props.searchBooks(requestBody, 0);
  };

  handleChange = (name, value) => {
    this.setState({
      smallModalData: {
        ...this.state.smallModalData,
        [name] : value
      }
    });
  }

  addBookToOrder = (row) => (event) => {
    event.preventDefault();

    const amount = event.target.amount.value;
    const digital_amount = event.target.digital_amount.value;
    const dataset = {
      "amount": amount || 0,
      "digital_amount": digital_amount || 0,
      "bookid": row.bookid
    };
    this.props.addBooks(dataset, this.props.modalData.id)
      .then(() => {
        this.props.bookRequestById(this.props.requestId);
        createNotification('success', notificationsLibrary['01']);
      })
      .catch(() => {
        createNotification('error', notificationsLibrary['02']);
      });
  }

  deleteBooksFromOrder = (requestId) => () => {
    const confirmDelete = window.confirm(`Вы действительно хотите удалить этот заказ?`);
    if(confirmDelete) {
      this.props.deleteBooks(requestId)
        .then(() => {
          this.props.bookRequestById(this.props.requestId);
          createNotification('success', notificationsLibrary['03']);
        });
    }
  }

  changeAmount = (row) => (event) => {
    event.preventDefault();

    this.handleSmallModal(false)();
    const requestId = row.id;
    const requestBody = {
      "amount": event.target.amount.value,
      "digital_amount": +event.target.digital_amount.value,
    }
    this.props.editOrder(requestId, requestBody)
      .then(() => {
        this.props.bookRequestById(this.props.requestId);
        createNotification('success', notificationsLibrary['04']);
      });
  }

  renderSearchResults = (row) => {
    const emptyImg = "data:image/png;base64,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";
    return (
      <div key={row.bookid} className="addBooksForm__results-item">
        <div className="addBooksForm__results-image">
          <img src={row.coverImage ? `https://biblio.nintegra.ru/public/images/library/covers/${row.bookid}/${row.coverImage}` : emptyImg} alt={row.title} />
        </div>
        <div className="addBooksForm__results-content">
          <h3>{row.title || '-'}</h3>
          <p>
            <span>Год:</span>
            {row.year || 'Не указано'}
          </p>
          <p>
            <span>Автор:</span>
            {row.authors || 'Не указано'}
          </p>
          <form onSubmit={this.addBookToOrder(row)}>
            <input type="number"
                   min="1"
                   max="1000000"
                   name="amount"
                   placeholder="Количество"
            />
            <input type="number"
                   min="0"
                   max="1000000"
                   name="digital_amount"
                   placeholder="Электронные копии"
            />
            <button type="submit">Заказать</button>
          </form>
        </div>
      </div>
    );
  }


  handleSmallModal = (visibility, row) => () => {
    this.setState({isEditModalVisible: visibility});

    if(row) {
      this.setState({smallModalData: row});
    }
  }

  renderBookorderRow = (row, index) => {
    return (
      <tr key={index} onDoubleClick={this.handleSmallModal(true, row)}>
        <td>{row.title}</td>
        <td>{row.authors ? row.authors.map((item) => item.name) : "Не указано"}</td>
        <td>{row.publishers ? row.publishers.map((item) => item.name) : "Не указано"}</td>
        <td>{row.amount}</td>
        <td>{row.digital_amount}</td>
        <td><button title="Удалить книги"
                    className="ddBooksForm__results-delete"
                    onClick={this.deleteBooksFromOrder(row.id)}
            ><img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNTA1Ljk0Myw2LjA1OGMtOC4wNzctOC4wNzctMjEuMTcyLTguMDc3LTI5LjI0OSwwTDYuMDU4LDQ3Ni42OTNjLTguMDc3LDguMDc3LTguMDc3LDIxLjE3MiwwLDI5LjI0OSAgICBDMTAuMDk2LDUwOS45ODIsMTUuMzksNTEyLDIwLjY4Myw1MTJjNS4yOTMsMCwxMC41ODYtMi4wMTksMTQuNjI1LTYuMDU5TDUwNS45NDMsMzUuMzA2ICAgIEM1MTQuMDE5LDI3LjIzLDUxNC4wMTksMTQuMTM1LDUwNS45NDMsNi4wNTh6IiBmaWxsPSIjMDAwMDAwIi8+Cgk8L2c+CjwvZz4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNTA1Ljk0Miw0NzYuNjk0TDM1LjMwNiw2LjA1OWMtOC4wNzYtOC4wNzctMjEuMTcyLTguMDc3LTI5LjI0OCwwYy04LjA3Nyw4LjA3Ni04LjA3NywyMS4xNzEsMCwyOS4yNDhsNDcwLjYzNiw0NzAuNjM2ICAgIGM0LjAzOCw0LjAzOSw5LjMzMiw2LjA1OCwxNC42MjUsNi4wNThjNS4yOTMsMCwxMC41ODctMi4wMTksMTQuNjI0LTYuMDU3QzUxNC4wMTgsNDk3Ljg2Niw1MTQuMDE4LDQ4NC43NzEsNTA1Ljk0Miw0NzYuNjk0eiIgZmlsbD0iIzAwMDAwMCIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=" alt={row.title}/></button></td>
      </tr>
    );
  }

  render() {
    const {
      isBookSearchOpen,
      isBookResultsRequested,
      isEditModalVisible,
      smallModalData
    } = this.state;

    const {
      libraryList,
      modalData,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={isEditModalVisible}
          contentLabel="SmallModal"
          onRequestClose={this.handleSmallModal(false)}
          className="StudentProjectSmallModal"
        >
          <EditBookRequestbookForm smallModalData={smallModalData} changeAmount={this.changeAmount} handleSmallModal={this.handleSmallModal} handleChange={this.handleChange}/>
        </Modal>
        <table className="ModalTable">
          <thead>
            <tr>
              <th className="table-title">Название</th>
              <th className="table-title">Авторы</th>
              <th className="table-title">Издательство</th>
              <th className="table-title">Количество</th>
              <th className="table-title">Электронная копия</th>
              <th className="table-title">Удалить</th>
            </tr>
          </thead>
          <tbody>
          {modalData.books && modalData.books.map(this.renderBookorderRow)}
          </tbody>
        </table>
        <div className="PR-StudProjModalFooter">
          <div>
            <button onClick={() => {this.setState({isBookSearchOpen: !isBookSearchOpen})}}>{isBookSearchOpen ? "Отменить" : "Добавить книгу"}</button>
          </div>
        </div>
        {isBookSearchOpen &&
        <React.Fragment>
          <BookSearchForm onSubmit={this.searchBooksList}/>
          <div>
            {isBookResultsRequested &&
              <div>
                <h3 className="addBooksForm__title">Результаты поиска</h3>
                <div className="addBooksForm__results">
                  {libraryList && libraryList.map(this.renderSearchResults)}
                </div>
              </div>
            }
          </div>
        </React.Fragment>
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(BooksRequestList);
